import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Grid,
} from '@mui/material';
import { Dispatch, SetStateAction, useState } from 'react';

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  link: string;
}

const ShareLinkDialog = ({ open, setOpen, link }: Props) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    if (window && window.navigator) {
      navigator.clipboard.writeText(link);
      setCopied(true);
    }
  };
  return (
    <Dialog
      open={open}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>History Link</DialogTitle>
      <DialogContent>
        <Grid container direction='column' spacing={1}>
          <Grid item>
            <Typography>
              The following is a link to your selected history:
            </Typography>
          </Grid>
          <Grid item>
            <Divider />
          </Grid>
          <Grid item style={{ width: '100%' }}>
            <Typography sx={{ width: '100%', wordWrap: 'break-word' }}>
              {link}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          color='secondary'
          onClick={handleCopy}
          disabled={copied}
        >
          {!copied ? 'Copy to Clipboard' : 'Copied'}
        </Button>
        <Button
          onClick={() => {
            setCopied(false);
            setOpen(false);
          }}
          color='primary'
          variant='contained'
          autoFocus
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareLinkDialog;
